import { render, staticRenderFns } from "./DigitalScriptTag.vue?vue&type=template&id=2fd31bdc&"
import script from "./DigitalScriptTag.vue?vue&type=script&lang=js&"
export * from "./DigitalScriptTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports